import Link from "next/link";
import { BsBoxArrowInRight, BsFillPersonFill } from "react-icons/bs";
import { useLanguage } from "@/providers/LanguageContext";
import { LanguageSelect } from "@/components/LanguageSelect";
import { Button } from "@/components/ui/Button";
import styles from "../Header.module.css";

interface DesktopNavigationProps {
  isAuthenticated: boolean;
  onContactClick: () => void;
  onAuthAction: () => void;
}

export function DesktopNavigation({ isAuthenticated, onContactClick, onAuthAction }: DesktopNavigationProps) {
  const { language } = useLanguage();

  return (
    <div className={styles.desktopMenu}>
      <Link href="/courses" className={styles.navLink}>
        {language === 'es' ? 'Cursos' : 'Courses'}
      </Link>
      <Link href="/articles" className={styles.navLink}>
        {language === 'es' ? 'Artículos' : 'Articles'}
      </Link>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          onContactClick();
        }}
        className={styles.contactButton}
      >
        {language === 'es' ? 'Contacto' : 'Contact'}
      </a>

      {/* Language Select */}
      <LanguageSelect />

      <Button
        variant="ghost"
        colorScheme="purple"
        onClick={onAuthAction}
        leftIcon={isAuthenticated ? <BsFillPersonFill /> : <BsBoxArrowInRight />}
      >
        {isAuthenticated
          ? (language === 'es' ? 'Panel' : 'Dashboard')
          : (language === 'es' ? 'Iniciar Sesión' : 'Login')
        }
      </Button>
    </div>
  );
}